module.exports = __webpack_public_path__ + "img/ja.8efeef0d.svg";